<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00061.installation.parampac.title' | translate"
      [description]="'P00061.installation.parampac.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00061.installation.parampac.compresseur.title' | translate"
      [titleListe]="
        'P00061.installation.parampac.compresseur.value' | translate
      "
      [description]="
        'P00061.installation.parampac.compresseur.description' | translate
      "
      [value]="actionStack!.getValue('wpPFonctionnementCompresseur')"
      [liste]="P00061FonctionnementCompresseur"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACWP_Parametrage1,
          'wpPFonctionnementCompresseur',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [title]="'P00061.installation.parampac.silence.title' | translate"
      [titleListe]="'P00061.installation.parampac.silence.value' | translate"
      [value]="actionStack!.getValue('wpPModeSilence')"
      [liste]="P00061ModeSilence"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACWP_Parametrage1,
          'wpPModeSilence',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [title]="'P00061.installation.parampac.fonctionnement.title' | translate"
      [titleListe]="
        'P00061.installation.parampac.fonctionnement.value' | translate
      "
      [value]="actionStack!.getValue('wpPModeFonctionnementTemperature')"
      [liste]="P00061FonctionnementPAC"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACWP_Parametrage1,
          'wpPModeFonctionnementTemperature',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
